export default __webpack_public_path__ + "static/media/lv.d56a0998.svg";